import { Column, Row, Section, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";

type Props = {
  date: string;
  startTime: string;
  endTime: string;
};

export const Schedule = ({ date, startTime, endTime }: Props) => {
  return (
    <Section style={Styles.schedule.content}>
      <Row style={Styles.schedule.tr}>
        <Column style={Styles.schedule.th}>When</Column>
        <Column style={Styles.schedule.td}>{date}</Column>
      </Row>
      {startTime && (
        <Row style={Styles.schedule.tr}>
          <Column style={Styles.schedule.th}>Start Time</Column>
          <Column style={Styles.schedule.td}>{startTime}</Column>
        </Row>
      )}
      {endTime && (
        <Row style={Styles.schedule.tr}>
          <Column style={Styles.schedule.th}>End Time</Column>
          <Column style={Styles.schedule.td}>{endTime}</Column>
        </Row>
      )}
    </Section>
  );
};
